<template>
  <v-card
      flat
      class="mx-auto"
      max-width="800"
      mim-width="350"
  >
    <v-tabs
        class="ml-3 mr-3"
        show-arrows
        v-model="activeTab"
        slider-color="primary">
      <v-tab
          class="font-weight-bold"
          v-for="tab in tabs"
          :value="tab.code"
          @click="getUpjangList(tab.code)">
        {{ tab.name }}
      </v-tab>
    </v-tabs>

    <v-window v-model="activeTab" class="ma-3">
      <v-window-item
          v-for="tab in tabs"
          :value="tab.code"
      >
      </v-window-item>
      <v-card>
        <v-row v-if="!upjangs || upjangs.length < 1" dense>
          <v-col cols="12">
            <v-card-text class="mt-2 text-body-1 text-center">준비중입니다.</v-card-text>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col
              v-for="upjang in upjangs"
              cols="12">
            <v-card
                :style="'border: 1px solid #BDBDBD'"
                class="rounded-lg"
                variant="outlined"
                :disabled="upjang.open_yn === 'N'"
                :to="`/upjang/${upjang.upjang_code}`">
              <div class="d-flex flex-no-wrap ">
                <v-avatar
                    class="ma-2"
                    size="90"
                    rounded="0">
                  <img width="90" :src="getRealImgPath(upjang.image_path)" @error="getImage">
                </v-avatar>
                <div class="pa-2">
                  <v-card-text class="pa-0 font-weight-bold text-body-1">
                    {{upjang.upjang_name}}
                  </v-card-text>
                  <v-card-text class="pa-0 pt-1 text-body-2">{{upjang.upjang_info}}</v-card-text>
                  <v-card-text class="pa-0 pt-1 text-body-2"
                               v-if="upjang.open_time.length === 4 && upjang.close_time.length === 4">
                    영업시간: {{upjang.open_time.substring(0,2)}}:{{ upjang.open_time.substring(2, 4) }}~{{upjang.close_time.substring(0,2)}}:{{ upjang.close_time.substring(2, 4) }}
                    <v-chip
                        v-if="upjang.open_yn !== 'Y'"
                        class="ma-0 mb-1"
                        color="red"
                        text-color="white"
                        size="x-small">
                      구매불가
                    </v-chip>
                  </v-card-text>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-window>
  </v-card>

  <MobileFooter></MobileFooter>

</template>

<script>
import MobileFooter from "@/components/common/MobileFooter";
import {common, upjang} from "@/api";
import authStore from '@/store/auth'
import commonStore from "@/store/common";
import shotUrlStore from "@/store/shotUrl";

export default {
  name: "Upjang",
  components: {MobileFooter},
  data() {
    return {
      activeTab: '',
      tabs: [],
      upjangs: [],
      isAuth: false,
    }
  },
  created() {
    this.isAuth = authStore.state.authInfo.token !== ''
    this.activeTab = shotUrlStore.state.routerInfo.upjangTab
        || this.$route.query.tab
        || '00'
    this.getCorpsCodes()
    this.getUpjangList(this.activeTab)
  },
  methods: {
    getCorpsCodes() {
      common.getCommonCode(commonStore.state.common.corpCode, ['BS001'])
          .then(data => {
            console.log(data)
            if (data.data.codes) {
              this.tabs.push({code: "00", name: "전체"})
              data.data.codes.forEach((item) => {
                this.tabs.push({code: item.detail, name: item.detail_name})
              })
            }
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    getUpjangList(code) {
      if (code === '00') {
        code = ''
      }
      upjang.getUpjangList(commonStore.state.common.corpCode, code)
          .then(data => {
            console.log(data)
            if (data.data.upjangs.length > 0) {
              this.upjangs = data.data.upjangs
            } else {
              this.upjangs = []
            }
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
  }
}
</script>

<style scoped>

</style>